var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlusBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8663 6.46676H7.53294V1.13343C7.53294 0.991982 7.47675 0.856327 7.37673 0.756307C7.27671 0.656288 7.14106 0.600098 6.99961 0.600098V0.600098C6.85816 0.600098 6.72251 0.656288 6.62249 0.756307C6.52247 0.856327 6.46628 0.991982 6.46628 1.13343V6.46676H1.13294C0.991494 6.46676 0.855839 6.52295 0.755819 6.62297C0.6558 6.72299 0.599609 6.85865 0.599609 7.0001H0.599609C0.599609 7.14155 0.6558 7.2772 0.755819 7.37722C0.855839 7.47724 0.991494 7.53343 1.13294 7.53343H6.46628V12.8668C6.46628 13.0082 6.52247 13.1439 6.62249 13.2439C6.72251 13.3439 6.85816 13.4001 6.99961 13.4001C7.14106 13.4001 7.27671 13.3439 7.37673 13.2439C7.47675 13.1439 7.53294 13.0082 7.53294 12.8668V7.53343H12.8663C13.0077 7.53343 13.1434 7.47724 13.2434 7.37722C13.3434 7.2772 13.3996 7.14155 13.3996 7.0001C13.3996 6.85865 13.3434 6.72299 13.2434 6.62297C13.1434 6.52295 13.0077 6.46676 12.8663 6.46676Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusBlack);
export default __webpack_public_path__ + "static/media/iconPlusBlack.8d15935cbf442a3c04aba71399f5e6fc.svg";
export { ForwardRef as ReactComponent };